import { Component } from '@angular/core';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';


  public onSwipe(e:any): void{
    console.log("onswipe");
    console.log(e);
  }

  public onSwipeLeft(e:any): void{
    console.log("onSwipeLeft");
    console.log(e);
  }

  public Tap(e:any): void{
    console.log("tap");
    console.log(e);
    
  }
}

